import { LinearProgress } from '@mui/material';
import React from 'react';

const Index: React.FC = () => {
  return (
    <div style={{ width: '100%' }}>
      <LinearProgress />
    </div>
  );
};
export default Index;
